var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestSuiteDisable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86585 10.1341L1.86585 12.7778C1.86585 13.4562 2.20977 14.0884 2.77935 14.4569L5.24049 16.0494C7.22399 17.3329 9.77601 17.3329 11.7595 16.0494L14.2206 14.4569C14.7902 14.0884 15.1341 13.4562 15.1341 12.7778L15.1341 10.1341",
    stroke: "#C4D7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.327 4.40606C7.64933 3.55044 9.35067 3.55044 10.673 4.40606L14.405 6.82086C15.623 7.60898 15.623 9.39102 14.405 10.1791L10.673 12.5939C9.35067 13.4496 7.64932 13.4496 6.32699 12.5939L2.59503 10.1791C1.37704 9.39102 1.37704 7.60898 2.59503 6.82086L6.327 4.40606Z",
    stroke: "#C4D7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4135 6.6148C8.07466 6.18698 8.92534 6.18698 9.5865 6.6148L12.3702 8.41604C12.4311 8.45545 12.4311 8.54455 12.3702 8.58396L9.5865 10.3852C8.92534 10.813 8.07466 10.813 7.4135 10.3852L4.62975 8.58396C4.56885 8.54455 4.56885 8.45545 4.62975 8.41604L7.4135 6.6148Z",
    stroke: "#C4D7E9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestSuiteDisable);
export default __webpack_public_path__ + "static/media/test-suite-disable.d9eddc9e76a8af08a319cf463b4fd0e0.svg";
export { ForwardRef as ReactComponent };